import { render, staticRenderFns } from "./ForestersWholeFR1.vue?vue&type=template&id=2c6f0f5e&scoped=true"
import script from "./ForestersWholeFR1.vue?vue&type=script&lang=js"
export * from "./ForestersWholeFR1.vue?vue&type=script&lang=js"
import style0 from "./ForestersWholeFR1.vue?vue&type=style&index=0&id=2c6f0f5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6f0f5e",
  null
  
)

export default component.exports